import {
  apiGet,
  apiPost,
  apiDelete,
  apiPut,
} from '../../api/index';
import { urlMallas } from '../../api/urls';

export function filter(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  return apiPost(`${urlMallas}/all`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function get(id, callback) {
  return apiGet(`${urlMallas}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function save(obj, callback) {
  return apiPost(`${urlMallas}`, obj)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function remove(id, callback) {
  return apiDelete(`${urlMallas}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function fetchFormDatas(params) {
  return apiGet(`${urlMallas}/form_data`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function getProfesorSubjects(params) {
  return apiGet(`${urlMallas}/materias_profesor/0`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function AllSubjectsDashboardByStudent(params) {
  return apiGet(`${urlMallas}/materias-tablero-alumno`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function getSubjectStudents(params) {
  const filters = params ? params.filters || {} : {};
  return apiPut(`${urlMallas}/alumnos-materia`, params.id, filters)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}
